import { AccountCircle, Logout, PersonAdd } from "@mui/icons-material";
import {
  Divider,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  styled,
} from "@mui/material";
import { useState } from "react";
import { Link } from "react-router-dom";
import AddPatientDialog from "./AddPatientDialog";
import AvatarInitialsProfile from "../AvatarInitialsProfile";
import { useClinicianContext } from "../ClinicianContext";
import { useMsal } from "@azure/msal-react";

const HeaderLink = styled(Link)({
  color: "inherit",
  textDecoration: "none",
});

const HeaderProfileDropdown = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const menuOpen = Boolean(anchorEl);
  const [showAddPatientDialog, setShowAddPatientDialog] = useState(false);
  const [clinician] = useClinicianContext();
  const { instance } = useMsal();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleAddPatient = () => {
    handleClose();

    setShowAddPatientDialog(true);
  };

  const handleCloseAddPatientDialog = () => {
    setShowAddPatientDialog(false);
  };

  const handleLogout = (event: React.MouseEvent<HTMLElement>) => {
    instance.logoutRedirect({
      postLogoutRedirectUri: "/",
    });
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        onClick={handleClick}
        size="small"
        sx={{ ml: 2 }}
        aria-controls={menuOpen ? "account-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={menuOpen ? "true" : undefined}
      >
        <AvatarInitialsProfile
          firstName={clinician.firstName}
          lastName={clinician.lastName}
        />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={menuOpen}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <HeaderLink to="profile">
          <MenuItem>
            <ListItemIcon>
              <AccountCircle />
            </ListItemIcon>
            View profile
          </MenuItem>
        </HeaderLink>
        <MenuItem onClick={handleAddPatient}>
          <ListItemIcon>
            <PersonAdd />
          </ListItemIcon>
          Add patient
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            {" "}
            <Logout />{" "}
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
      <AddPatientDialog
        open={showAddPatientDialog}
        onClose={handleCloseAddPatientDialog}
      />
    </>
  );
};

export default HeaderProfileDropdown;
